import { TextField } from "@mui/material";
import React from "react";

const CoreInputField = ({ ...props }) => {
  return (
    <TextField
      sx={{ mt: props.avoidMt ? 0 : 2 }}
      size="small"
      {...props} // Aggiungi helperText per visualizzare il messaggio di errore
    >
      {props.children}
    </TextField>
  );
};

export default CoreInputField;
